/* eslint-env jquery */
/* eslint-disable func-names */
/**
 * Webinar Series Component
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'webinar-series';

class WebinarSeries extends Component {

    /**
     * Initialize Component
     */
    init() {

        // Add sort-value attr to ul's (from sort-date attr in li)
        $('.webinar-instance__startDate').each(
            function() {
                const sortVal = Date.parse($(this).data('webinar-date').substring(0, 16));
                const todaysDate = new Date();
                const pastOrFuture = sortVal < Date.parse(todaysDate) ? 'on-demand' : 'upcoming';
                $(this).parents('.webinar-instance').attr('data-sort-status', pastOrFuture).attr('data-sort-value', sortVal);
            }
        );

        // Order webinars by date
        const webinarList = $('.series-instances');
        const webinars = $('.webinar-instance[data-sort-value]');
        webinars.sort((a, b) => $(a).data('sort-value') - $(b).data('sort-value'));
        webinars.prependTo(webinarList);
        // Display future webinars first (upcoming) then past webinars (on-demand)
        const pastWebinars = $('.webinar-instance[data-sort-status = "on-demand"]');
        const futureWebinars = $('.webinar-instance[data-sort-status = "upcoming"]');
        pastWebinars.prependTo(webinarList);
        futureWebinars.prependTo(webinarList);
    }
}

registerComponent(`.${componentName}`, WebinarSeries);
